module.exports = __webpack_public_path__ + "static/media/blue-dollar.cc3454f8.svg";